<template>
  <f7-block>
    <f7-block-title>{{ $t('marketplaceDashboard.orders') }}</f7-block-title>
    <div class="metric-grid">
      <div class="metric-card">
        <span class="metric-lbl">{{ $t('marketplaceDashboard.pendingOrders') }}</span>
        <span class="metric-val">{{ fmt(data.pendingOrders) }}</span>
      </div>
      <div class="metric-card">
        <span class="metric-lbl">{{ $t('marketplaceDashboard.processingOrders') }}</span>
        <span class="metric-val">{{ fmt(data.processingOrders) }}</span>
      </div>
      <div class="metric-card">
        <span class="metric-lbl">{{ $t('marketplaceDashboard.shippedOrders') }}</span>
        <span class="metric-val">{{ fmt(data.shippedOrders) }}</span>
      </div>
      <div class="metric-card">
        <span class="metric-lbl">{{ $t('marketplaceDashboard.deliveredOrders') }}</span>
        <span class="metric-val">{{ fmt(data.deliveredOrders) }}</span>
      </div>
      <div class="metric-card">
        <span class="metric-lbl">{{ $t('marketplaceDashboard.cancelledOrders') }}</span>
        <span class="metric-val">{{ fmt(data.cancelledOrders) }}</span>
      </div>
      <div class="metric-card">
        <span class="metric-lbl">{{ $t('marketplaceDashboard.ordersToday') }}</span>
        <span class="metric-val">{{ fmt(data.ordersToday) }}</span>
      </div>
      <div class="metric-card" v-if="data.orderCompletionRate != null">
        <span class="metric-lbl">{{ $t('marketplaceDashboard.orderCompletionRate') }}</span>
        <span class="metric-val">{{ pct(data.orderCompletionRate) }}</span>
      </div>
    </div>
  </f7-block>
</template>
<script setup>
const props = defineProps({ data: { type: Object, required: true } });
function fmt(n) { return n != null ? Math.round(n).toLocaleString('fr-FR') : '-'; }
function pct(v) { return v != null ? v.toFixed(1) + '%' : '-'; }
</script>
<style scoped>
.metric-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(150px, 1fr)); gap: 10px; }
.metric-card { display:flex; flex-direction:column; align-items:center; gap:4px; padding:14px 8px; border-radius:12px; background:var(--f7-list-bg-color,#f5f5f5); }
.metric-lbl { font-size:11px; color:var(--f7-on-surface-variant,#8e8e93); text-align:center; line-height:1.3; }
.metric-val { font-size:18px; font-weight:700; color:var(--f7-text-color,#333); }
</style>